function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Groupe_801",
  "data-name": "Groupe 801",
  transform: "translate(-4047 -2967)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_1012",
  "data-name": "Trac\\xE9 1012",
  d: "M14,402a2,2,0,0,0-4,0v6a2,2,0,0,0,4,0Zm-6,0a4,4,0,0,1,8,0v6a4,4,0,0,1-8,0Zm12,6v-2H18v2a6,6,0,0,1-12,0v-2H4v2a8,8,0,0,0,7,7.938V419h2v-3.062A8,8,0,0,0,20,408Z",
  transform: "translate(4046 2569)",
  fill: "current",
  fillRule: "evenodd"
}));

function SvgMicrophoneOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22.83,
    viewBox: "0 0 22 22.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophoneOn);
export default __webpack_public_path__ + "static/media/microphone-on.310ff6a6.svg";
export { ForwardRef as ReactComponent };